import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Mail, Building2, MapPin, Clock, MessageCircle } from 'lucide-react';

const ContactUs = () => {
  const handleEmail = () => {
    window.location.href = 'mailto:info@myvenuemate.in';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <div className="p-2 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-lg text-white">
            <MessageCircle className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-white">Contact Us</h2>
            <p className="text-sm text-slate-400">Last updated on Dec 17th 2025</p>
          </div>
        </div>

        <Card className="border-slate-700 bg-slate-800/50 shadow-md overflow-hidden">
          <div className="bg-gradient-to-r from-teal-500 to-cyan-600 p-6 text-white">
            <h3 className="text-xl font-semibold mb-2">Get in Touch</h3>
            <p className="text-teal-100">We are here to help you with any questions about MyVenueMate</p>
          </div>
          <CardContent className="p-6 space-y-6">
            {/* Company Info */}
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="p-2 bg-teal-500/20 rounded-lg">
                  <Building2 className="w-5 h-5 text-teal-400" />
                </div>
                <div>
                  <h4 className="font-semibold text-white">Company Name</h4>
                  <p className="text-slate-400">MYONK</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-2 bg-teal-500/20 rounded-lg">
                  <MapPin className="w-5 h-5 text-teal-400" />
                </div>
                <div>
                  <h4 className="font-semibold text-white">Address</h4>
                  <p className="text-slate-400">
                    MYONK<br />
                    Bengaluru, Karnataka, India
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-2 bg-teal-500/20 rounded-lg">
                  <Mail className="w-5 h-5 text-teal-400" />
                </div>
                <div>
                  <h4 className="font-semibold text-white">Email</h4>
                  <p className="text-slate-400">info@myvenuemate.in</p>
                  <Button 
                    onClick={handleEmail}
                    className="mt-2 bg-teal-600 hover:bg-teal-700"
                    size="sm"
                  >
                    <Mail className="w-4 h-4 mr-2" />
                    Send Email
                  </Button>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-2 bg-teal-500/20 rounded-lg">
                  <Clock className="w-5 h-5 text-teal-400" />
                </div>
                <div>
                  <h4 className="font-semibold text-white">Business Hours</h4>
                  <p className="text-slate-400">Monday - Saturday: 9:00 AM - 6:00 PM IST</p>
                  <p className="text-slate-500 text-sm">Sunday: Closed</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Back to Home */}
        <div className="text-center pt-4">
          <Button 
            variant="outline"
            onClick={() => window.location.href = '/'}
            className="border-slate-600 text-slate-300 hover:bg-slate-700/50"
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
